import UserForm from './UserForm';

export function CreateUserForm() {
  return (
    <>
      <UserForm formName="user" />
    </>
  );
}
